export const onCardHoverText = 'View Test Dashboard';
